import React from "react";
import {Button, Form, Icon, Modal, Radio, Select, Switch, Upload, message} from "antd";
import Input from "antd/es/input";
import {WasteStreamFilter} from "../../../filters/WasteStreamCode";
import {BillToFilter} from "../../../filters/BillTo";
import {GeneratorFilter} from "../../../filters/Generator";
import {Config} from "../../../controller/Global";
import {getUserToken} from "../../../controller/AuthService";
import {WasteProfileGet} from "../../../models/waste_profile/wasteProfile";

const axios = require('axios');
const FormItem = Form.Item;
const _ = require('lodash');
const RadioGroup = Radio.Group;
const Option = Select.Option;


class AddWasteProfileForm extends React.Component {
    state = {
        file: null,
        image_required: false,
        pcb_field:false,
        file_location: "",
        layered:false,
        flashPoint:{},

    };

    changeFileUpload = (value) => {
        this.setState({image_required: value})
    }
    setFields=()=>{
        const form = this.props.form;
        WasteProfileGet(this.props.id)
            .then(response => {
                const composition = response.data.composition;
                form.setFieldsValue({
                    process_description:response.data.process_description,
                    ph:response.data.ph,
                    oil:response.data.physical_prop.oil,
                    water:response.data.physical_prop.water,
                    solids:response.data.physical_prop.solids,
                    color:response.data.physical_prop.color,
                    flash_point: response.data.flash_point,
                    pcb:response.data.pcb,
                    total_halogen:response.data.total_halogen,
                    layered:response.data.physical_prop.layered,
                    compound_name1: composition.composition1[0],
                    compound_percent1: composition.composition1[1],
                    compound_name2: composition.composition2[0],
                    compound_percent2: composition.composition2[1],
                    compound_name3: composition.composition3[0],
                    compound_percent3: composition.composition3[1],
                    laboratory: Boolean(response.data.laboratory_analysis)
                });

                this.generator.handleChange({
                  key: response.data.generator.id,
                  label: response.data.generator.label
                });
                this.bill_to.handleChange({
                  key: response.data.bill_to.id,
                  label: response.data.bill_to.label
                });
                this.waste_stream.handleChange({
                  key: response.data.waste_stream.id,
                  label: response.data.waste_stream.label
                });
                this.setState({image_required:response.data.laboratory_analysis,
                file_location:response.data.laboratory_analysis})

            })
    }
    componentDidMount(){
        this.props.id && this.setFields();
    }

    handleWasteProfile = () => {
        const form = this.props.form;
        const {file, image_required} = this.state;
        const formData = new FormData();
        form.validateFields((err, values) => {
            if (!err) {
                values['composition'] = JSON.stringify({
                    'composition1': [_.get(values, 'compound_name1'), _.get(values, 'compound_percent1')],
                    'composition2': [_.get(values, 'compound_name2'), _.get(values, 'compound_percent2')],
                    'composition3': [_.get(values, 'compound_name3'), _.get(values, 'compound_percent3')],
                });
                values['physical_prop'] = JSON.stringify(_.pick(values, ["color", "matter_type", "oil", "solids", "strong_type", "water", "layered"]));

                if(file && image_required)
                    values['laboratory_analysis'] = file;

                _.forIn(values, function (value, key) {
                    formData.append(key, value)
                });
                if (this.props.id) {
                    axios.patch(Config['domain'] + Config['api']['tracks']['waste_profile']['patch']+ this.props.id+'/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Token ' + getUserToken()
                        }
                    })
                    .then(response => {
                        message.success("Updated waste profile successfully");
                        this.props.fetch();
                        this.props.onCancel();
                    })
                }
                else {
                    axios.post(Config['domain'] + Config['api']['tracks']['waste_profile']['post'], formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Token ' + getUserToken()
                        }
                    })
                    .then(response => {
                        message.success("Added waste profile successfully");
                        this.props.fetch();
                        this.props.onCancel();
                    })
                }
            }
            console.log(err, values)
        })
    };

    handleFileUpload = (obj) => {
        this.setState({file: obj.file})
    };
    handleChangeUpload = url => {
    this.setState({ fileList:url });
  };
    handleImageLocationField = (file_location) => {
        this.setState({file_location})
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {visible,id, form} = this.props;
        const {image_required,fields, file_location} = this.state;
        return (
            <Modal title={id ? "Edit Waste Profile Record":"Add Waste Profile Record"} className="create-quote-btn" centered
                   visible={visible} okText={id ? "Edit Waste Profile":"Add Waste Profile"}
                   onOk={this.handleWasteProfile}
                   onCancel={this.props.onCancel} width="70%" destroyOnClose={true}>
                <div className="col-xs-12 paddingZ add-item-inner floating-form">
                    <Form>
                        <div className="row full-floating-inputs">
                            <div className="col-sm-4 col-12 pos-relative">
                                <div className="floating-label">
                                    <FormItem label="Generator">
                                        {getFieldDecorator('generator', {
                                            rules: [{required: true, message: 'Please select generator'}],
                                        })(<GeneratorFilter onRef={ref => (this.generator = ref)} {...fields}  disableBill={true}/>)}
                                    </FormItem>
                                </div>
                            </div>
                          <div className="col-sm-4 col-12 pos-relative">
                                <div className="floating-label">
                                    <FormItem label="Bill To">
                                        {getFieldDecorator('bill_to', {
                                            rules: [{required: true, message: 'Please select bill to'}],
                                        })(<BillToFilter onRef={ref => (this.bill_to = ref)} {...fields}/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Waste Stream">
                                        {getFieldDecorator('waste_stream', {
                                            rules: [{required: true, message: 'Please select Waste Stream'}],
                                        })(<WasteStreamFilter onRef={ref => (this.waste_stream = ref)} {...fields} />)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="floating-label">
                                    <FormItem label="Process Description">
                                        {getFieldDecorator('process_description', {
                                            rules: [{required: true, message: 'Please select process description'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-12">
                              <div className="row mx-0 compound-row">
                                <div className="col-12">
                                  <label className="ant-form-item-required">Composition(must add upto 100%)</label>
                                </div>
                                <div className="col-sm-2 col-12">
                                  <label>Compound</label>
                                </div>
                                <div className="col-sm-6 col-12">
                                  <FormItem>
                                       {getFieldDecorator('compound_name1')(<Input placeholder="Enter Here"/>)}
                                  </FormItem>
                                </div>
                                <div className="col-sm-4 col-12">
                                   {getFieldDecorator('compound_percent1')(<Input addonAfter="%" init={"000"} placeholder="Enter Here"/>)}
                                </div>
                              </div>
                              <div className="row mx-0 compound-row">
                                <div className="col-sm-2 col-12">
                                  <label>Compound</label>
                                </div>
                                <div className="col-sm-6 col-12">
                                  <FormItem>
                                       {getFieldDecorator('compound_name2')(<Input placeholder="Enter Here"/>)}
                                  </FormItem>
                                </div>
                                <div className="col-sm-4 col-12">
                                   {getFieldDecorator('compound_percent2')(<Input addonAfter="%" init={"000"} placeholder="Enter Here"/>)}
                                </div>
                              </div>
                              <div className="row mx-0 compound-row">
                                <div className="col-sm-2 col-12">
                                  <label>Compound</label>
                                </div>
                                <div className="col-sm-6 col-12">
                                  <FormItem>
                                       {getFieldDecorator('compound_name3')(<Input placeholder="Enter Here"/>)}
                                  </FormItem>
                                </div>
                                <div className="col-sm-4 col-12">
                                   {getFieldDecorator('compound_percent3')(<Input addonAfter="%" init={"000"} placeholder="Enter Here"/>)}
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="row mx-0 physical-prop-div">
                                  <div className="col-12">
                                    <label className="ant-form-item-required">Physical Properties</label>
                                  </div>
                                  <div className="col-sm-3 col-12">
                                      {getFieldDecorator('matter_type', {
                                            rules: [{required: true, message: 'Please choose state'}],
                                            initialValue: "liquid"
                                        })(
                                      <RadioGroup>
                                          <Radio value={"liquid"}>Liquid</Radio>
                                          <Radio value={"solid"}>Solid</Radio>
                                      </RadioGroup>)}
                                  </div>
                                  <div className="col-sm-3 col-12 layered-div ">
                                      <label style={{width:"30%"}}>Layered</label>
                                      {getFieldDecorator('layered', {
                                        })(<Switch checked={form.getFieldValue('layered')} checkedChildren={true} unCheckedChildren={false}/>)}
                                  </div>
                                  <div className="col-sm-3 col-12">
                                    <label style={{width:"20%"}}>Color</label>
                                      {getFieldDecorator('color', {
                                        })(<Input style={{width:"80%"}} placeholder="Enter Here"/>)}
                                  </div>
                                  <div className="col-sm-3 col-12">
                                      {getFieldDecorator('strong_type', {
                                          initialValue: "mild"
                                        })(<RadioGroup>
                                          <Radio value={"mild"}>Mild</Radio>
                                          <Radio value={"strong"}>Strong</Radio>
                                      </RadioGroup>)}
                                  </div>
                                  <div className="col-sm-4 col-12">
                                    <label style={{width:"20%"}}>Oil</label>
                                       {getFieldDecorator('oil', {
                                        })(<Input addonAfter="%" style={{width:"80%"}} placeholder="Enter Here"/>)}
                                  </div>
                                  <div className="col-sm-4 col-12">
                                    <label style={{width:"20%"}}>Water</label>
                                       {getFieldDecorator('water', {
                                        })(<Input addonAfter="%" style={{width:"80%"}} placeholder="Enter Here"/>)}
                                  </div>
                                  <div className="col-sm-4 col-12">
                                    <label style={{width:"20%"}}>Solids</label>
                                       {getFieldDecorator('solids', {
                                        })(<Input addonAfter="%" style={{width:"80%"}} placeholder="Enter Here"/>)}
                                  </div>
                              </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Flash Point">
                                        {getFieldDecorator('flash_point', {
                                            rules: [{required: true, message: 'Please select flash point'}],
                                        })(<Select showSearch className="show-icon" style={{ width: "100%" }} placeholder="Select Here" optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            <Option value="< 100F">&lt; 100F</Option>
                                            <Option value="> 100F">&gt; 100F</Option>
                                            <Option value="< 140F">&lt; 140F</Option>
                                            <Option value="> 140F">&gt; 140F</Option>
                                            <Option value="< 200F">&lt; 200F</Option>
                                            <Option value="> 200F">&gt; 200F</Option>
                                          </Select>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="pH">
                                        {getFieldDecorator('ph', {
                                            rules: [{required: true, message: 'Please enter pH'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Total Halogen">
                                        {getFieldDecorator('total_halogen', {
                                            rules: [{required: true, message: 'Please enter'}],
                                        })(<Select showSearch className="show-icon" style={{ width: "100%" }} placeholder="Select a person" optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            <Option value="< 1000ppm"> &lt; 1000ppm </Option>
                                            <Option value="> 1000ppm">&gt; 1000ppm</Option>
                                            <Option value="N/A">N/A</Option>
                                          </Select>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="PCB'S">
                                        {getFieldDecorator('pcb', { valuePropName: 'checked', initialValue:false })(<Switch checkedChildren={true} unCheckedChildren={false}/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-8 col-12">
                                <div className="floating-label">
                                    <FormItem label="Is there laboratory analysis?">
                                        {getFieldDecorator('laboratory', { valuePropName: 'checked', initialValue:false })(<div>
                                            <Switch style={{marginRight: "25px"}}
                                                    checkedChildren={true}
                                                    checked={Boolean(this.state.image_required)}
                                                    onChange={this.changeFileUpload}
                                                    unCheckedChildren={false}/>
                                            {image_required ?
                                                <Upload beforeUpload={() => false} onChange={this.handleFileUpload}>
                                                    <Button>
                                                        <Icon type="upload"/> Choose File
                                                    </Button>
                                                </Upload> : ''}
                                            {file_location && <a href={file_location.toString()} target="_blank">Download File</a>}
                                        </div>)}
                                    </FormItem>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal>
        )
    }
}

export const AddWasteProfile = Form.create()(AddWasteProfileForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/waste_profile/AddWasteProfile.jsx